export default __webpack_public_path__ + "static/media/correct.2d8bca46.wav";